import { ChangeDetectorRef, Component, OnInit, SimpleChange } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationStart, Params, Router } from '@angular/router';
@Component({
  selector: 'app-content-layout',
  templateUrl: './content-layout.component.html',
  styleUrls: ['./content-layout.component.css']
})
export class ContentLayoutComponent implements OnInit {
  currentUrl: any;
  categoryUrl:any;
  ifNews:boolean = false;
  ifVideo:boolean = false;

  constructor(private router: Router,
    private _route: ActivatedRoute,   private cdRef : ChangeDetectorRef,) { }

  ngOnInit(): void {
    this.currentUrl = '/';
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = this.router.url;
        this.ifNews = this.currentUrl.includes('news') || this.currentUrl.includes('podcast-web')  ? true : false;
        // this.ifNews = (this.currentUrl.includes('news') && !this.currentUrl.includes('news/videos')) || this.currentUrl.includes('podcast-web')  ? true : false;
        // this.ifNews = this.currentUrl.includes('podcast-web')  ? true : false;
        // this.ifNews = this.currentUrl.includes('podcast-web')  ? true : false;
        // this.ifNews = this.currentUrl.includes('podcast-web')  ? true : false;
        // this.ifVideo = (this.currentUrl.includes('news') && this.currentUrl.includes('news/videos'))  ? true : false;
      }
    })
  }

  ngAfterViewInit(){
    this.currentUrl = this.router.url;
    this.ifNews = this.currentUrl.includes('news') || this.currentUrl.includes('podcast-web')  ? true : false;

    // this.ifNews = (this.currentUrl.includes('news') && !this.currentUrl.includes('news/videos')) || this.currentUrl.includes('podcast-web')  ? true : false;
    // this.ifVideo = (this.currentUrl.includes('news') && this.currentUrl.includes('news/videos'))  ? true : false;
    // this.ifNews = this.currentUrl.includes('news/videos') || this.currentUrl.includes('podcast-web')  ? true : false;

    // this.ifNews = this.currentUrl.includes('podcast-web') ? true : false;
    this.cdRef.detectChanges();
  }


}
